import { parsePhoneNumberFromString } from 'libphonenumber-js';

/**
 * Normalize a phone number to canonical E.164 (e.g. "+18761234567").
 *
 * The shared phone `InputField` (type="phone") emits E.164, but values stored
 * before the international rollout may be bare digits (e.g. "18761234567" or
 * "8761234567") which the widget can't parse on load. Run those through this
 * helper so the country selector pre-fills correctly.
 *
 * - Already-"+"-prefixed values are re-parsed and returned canonical.
 * - Bare values are parsed with Jamaica ("JM") as the default region.
 * - Empty/whitespace returns "".
 * - Unparseable input is returned unchanged.
 */
export const toE164 = (value?: string | null): string => {
  const raw = (value ?? '').trim();
  if (!raw) return '';

  const parsed = raw.startsWith('+')
    ? parsePhoneNumberFromString(raw)
    : parsePhoneNumberFromString(raw, 'JM');

  return parsed?.number ?? raw;
};
